<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

.center{
  text-align: center;
}

.center2{
  margin-top: 30px;
  text-align: center;
  color: white;
}

.icon-check{
  font-size: 60px;
  color: green;
}

.icon-clear{
  font-size: 40px;
  color: red;
}
.does-not-match{
  font-size: 25px;
  color: white;
}

.clear-code-margin{
  margin-top: 10px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Verify your email</h3>
<div class="space"><TextMessageCode bind:verifyCode="{emailCode}" on:check="{check}" on:clear="{ () => {valid = -1} }"></TextMessageCode></div>
<div class="space small">Check your email for a six digit code.  If you don't see anything, make sure to check your spam box.</div>

{#if valid == -1 || valid == 0}
<div class="space center" on:click="{sendCodeAgain}"><i class="icon-refresh"></i> Send code again</div>
{/if}

<div class="center2">
  {#if valid == 1}
    <div>
      <i class="icon-check"></i>
    </div>
    <div>
      Verified!
    </div>
  {:else if valid == 0}
    <i class="icon-clear"></i>
    <div class="does-not-match">Sorry, that does not match</div>
    <div class="clear-code-margin"><button on:click="{clearCode}">Try Again</button></div>
  {/if}
</div>

{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

import TextMessageCode from "../../components/TextMessageCode.svelte";

export let show = false;
export let me = null;

let emailCode = "";
let valid = -1;


async function check() {
  if (emailCode.length != 6) return;
  
  try {
    Validate.textCode(emailCode);
    // await Signup.verifyEmail(emailCode);
    let res = await auth.post("verifyEmail", {verifyCode: emailCode}, false);
    if (res == "-") throw "verify code was not valid";
    valid = 1;
  } catch (e) {
    valid = 0;
    console.log("error:", e);
  }
}


function clearCode() {
  emailCode = "";
  valid = -1;
}


function sendCodeAgain() {
  // resend the validation code
  // set up a timeout so they can't send a new code a bunch of times
}


export const save = async () => {
  // nothing to do here...
}



</script>